import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, Skeleton, Typography } from "antd";

const { Text } = Typography;

const UserTaskDetailsScreen = (props: any) => {
  const {
    task,
    loading,
    actions: { getTaskById, learnerSubmitTask },
  } = props;
  const id = useParams().id;
  const [showMoreDescription, setShowMoreDescription] = useState(false);
  const charMax = 225;
  const navigate = useNavigate();

  useEffect(() => {
    id && getTaskById({ id });
  }, [id]);

  if (loading) return <Skeleton active />;

  return (
    <div>
      <div className="xl:flex pb-[40px]">
        <div className="xl:w-1/2">
          <Card className="p-6 border-none shadow-sm">
            <div className="flex flex-col gap-6">
              <div>
                <Text className="text-neutral-600 text-sm font-semibold block">
                  Task Title
                </Text>
                <Text className="bg-neutral-100 rounded-lg mt-2 p-4 block text-neutral-600 text-base font-semibold">
                  {task?.title}
                </Text>
              </div>

              <div>
                <Text className="text-neutral-600 text-sm font-semibold block">
                  Description
                </Text>
                <div className="bg-neutral-100 rounded-lg mt-2 p-4">
                  <Text
                    className={`text-neutral-600 text-base block overflow-hidden ${
                      !showMoreDescription ? "max-h-[144px]" : "h-auto"
                    } `}
                  >
                    {!showMoreDescription
                      ? `${task?.description.substring(0, charMax)} ${
                          task?.description.length > charMax ? ".." : ""
                        } `
                      : task?.description}
                  </Text>
                  {task?.description.length > charMax && (
                    <Text
                      onClick={() => setShowMoreDescription((prev) => !prev)}
                      className="text-sm text-primary-600 font-semibold block mt-2 cursor-pointer w-fit"
                    >
                      {!showMoreDescription ? "More" : "Less"}
                    </Text>
                  )}
                </div>
              </div>

              {task?.coverImageKey && (
                <div>
                  <Text className="text-neutral-600 text-sm font-semibold block">
                    Cover Image
                  </Text>
                  <img
                    src={
                      task?.coverImageKey
                        ? `${process.env.REACT_APP_CLOUDFRONT_KEY}/${task?.coverImageKey}`
                        : ""
                    }
                    alt="cover"
                    className="rounded-lg w-full  mt-2 mb-6"
                  />
                </div>
              )}
            </div>
          </Card>
        </div>
        <div className="flex w-1/2 justify-end">
          {!task?.isFinished && !task?.isApproved && (
            <Button
              loading={loading}
              disabled={loading}
              onClick={() => learnerSubmitTask({ id: task?.id, navigate })}
              type="primary"
              className="w-1/2 h-[50px] bg-primary-600 text-white font-semibold rounded-lg ml-6"
            >
              Submit Task
            </Button>
          )}
          {task?.isFinished && !task?.isApproved && (
            <Text className="w-1/2 h-[50px] text-base flex justify-center items-center font-semibold bg-primary-600 text-white rounded-lg ml-6">
              Submitted
            </Text>
          )}
          {task?.isFinished && task?.isApproved && (
            <Text className="w-1/2 h-[50px] text-base flex justify-center items-center font-semibold bg-success-550 text-white rounded-lg ml-6">
              Approved
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserTaskDetailsScreen;
